import { FC, useState } from "react";
import AddCard from "../AddCard";
import { DateTime } from "luxon";
import { SuspectedHeadacheType } from "../../types";
import AttackDialog from "./AttackDialog";

interface AddAttackCardProps {
  addAttack: (newAttack: {
    startDateTime: DateTime;
    endDateTime: DateTime;
    awake: boolean;
    disabledForTwoHours: boolean;
    suspectedHeadacheType: SuspectedHeadacheType;
    notes: string;
  }) => void;
}

const AddAttackCard: FC<AddAttackCardProps> = ({ addAttack }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <AddCard onClick={handleOpen} />
      <AttackDialog
        addAttack={addAttack}
        handleClose={handleClose}
        open={open}
        variant="add"
      />
    </>
  );
};

export default AddAttackCard;
